import config from '@/config/config.js';
import { http } from '@/common/request';
import errorCode from '@/api/error-code.js'
export default {
    /***************************************************** start *******************************************/



    uploadImage(image){
        let params = {
        }
        let data = {
            'image':image
        }
        const formData = new FormData();
        formData.append('image', image);
        const options = {};
        options.params = params;
        return  http.postForm("/api/v3/common/upload/uploadImage", formData, {});
    },









    /***************************************************** end *********************************************/
}
